import { render, staticRenderFns } from "./BrandCategory.vue?vue&type=template&id=340c1354&scoped=true"
import script from "./BrandCategory.vue?vue&type=script&lang=js"
export * from "./BrandCategory.vue?vue&type=script&lang=js"
import style0 from "./BrandCategory.vue?vue&type=style&index=0&id=340c1354&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340c1354",
  null
  
)

export default component.exports